// calculator source: https://github.com/blevic/nrarfcn/tree/main
const KHZ_TO_MHZ = 1000.0;

export const NRARFCN_MAX = 3_279_165;
export const NRARFCN_MIN = 0;

export const FREQ_MAX = 99_999.96;
export const FREQ_MIN = 0;

const LOW_BAND_MAX_NRARFCN = 599_999;
const MID_BAND_MAX_NRARFCN = 2_016_666;

const LOW_BAND_F_OFFSET = 0;
const MID_BAND_F_OFFSET = 3000.0 * KHZ_TO_MHZ;
const HIGH_BAND_F_OFFSET = 24_250.08 * KHZ_TO_MHZ;

const LOW_BAND_DELTA_F = 5.0;
const MID_BAND_DELTA_F = 15.0;
const HIGH_BAND_DELTA_F = 60.0;

const LOW_BAND_N_OFFSET = 0;
const MID_BAND_N_OFFSET = 600_000.0;
const HIGH_BAND_N_OFFSET = 2_016_667.0;

export const T5GConverter = {
	nrarfcnToFreq: (nrarfcn: number): number => {
		if (nrarfcn < NRARFCN_MIN || nrarfcn > NRARFCN_MAX) return NaN;

		let fOffset, deltaF, nOffset;

		if (nrarfcn <= LOW_BAND_MAX_NRARFCN) {
			fOffset = LOW_BAND_F_OFFSET;
			deltaF = LOW_BAND_DELTA_F;
			nOffset = LOW_BAND_N_OFFSET;
		} else if (nrarfcn <= MID_BAND_MAX_NRARFCN) {
			fOffset = MID_BAND_F_OFFSET;
			deltaF = MID_BAND_DELTA_F;
			nOffset = MID_BAND_N_OFFSET;
		} else {
			fOffset = HIGH_BAND_F_OFFSET;
			deltaF = HIGH_BAND_DELTA_F;
			nOffset = HIGH_BAND_N_OFFSET;
		}

		const freqKHz = fOffset + deltaF * (nrarfcn - nOffset);
		const freqMHz = freqKHz / KHZ_TO_MHZ;

		return Math.round(freqMHz * KHZ_TO_MHZ) / KHZ_TO_MHZ;
	},
	freqToNrarfcn: (freq: number): number => {
		if (freq < FREQ_MIN || freq > FREQ_MAX) return NaN;

		let fOffset, deltaF, nOffset;

		if (freq <= MID_BAND_F_OFFSET / KHZ_TO_MHZ) {
			fOffset = LOW_BAND_F_OFFSET;
			deltaF = LOW_BAND_DELTA_F;
			nOffset = LOW_BAND_N_OFFSET;
		} else if (freq <= HIGH_BAND_F_OFFSET / KHZ_TO_MHZ) {
			fOffset = MID_BAND_F_OFFSET / KHZ_TO_MHZ;
			deltaF = MID_BAND_DELTA_F;
			nOffset = MID_BAND_N_OFFSET;
		} else {
			fOffset = HIGH_BAND_F_OFFSET / KHZ_TO_MHZ;
			deltaF = HIGH_BAND_DELTA_F;
			nOffset = HIGH_BAND_N_OFFSET;
		}

		const nrarfcn = nOffset + (freq - fOffset) * KHZ_TO_MHZ / deltaF;

		return Math.min(Math.round(nrarfcn), NRARFCN_MAX);
	},
};
